/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes, { any } from 'prop-types';
import { find } from 'lodash';
import moment from 'moment';
import Dotdotdot from 'react-dotdotdot';

import { Link } from 'react-router-dom';
import PopOverMenu from '../../PopOverMenu';
import { Utr, UtrLabel } from '../../text';
import Description from '../../text/Description';
import withAuth from '../../hocs/withAuth';
import BackgroundImage from '../../BackgroundImage';
import { CLUB_PROFILE_VIEW_TYPES } from '../../../utils/constants';
import { isNewRosterModelEnabled } from '../../../utils/statsig';

const _ = { find };

class InvitedPlayerCard extends Component {
    render() {
        const {
            rank,
            player,
            currentDivision,
            showPlayerStatus,
            showPlayerPaymentStatus,
            utrType,
            menuOptions,
            menuOnSelected,
            showSeeProfileLink,
            forceCardView,
            force = {},
            addOptionsSpace,
            showDecimals,
            showClubCollegeDetails,
            clubProfileViewType,
            showActionRequiredBackground,
            auth,
            showRatingNotLoggedIn,
            sendMessage,
            sportTypeId,
            checkGate,
            featureGates,
            'data-testid': dataTestId,
        } = this.props;

        const {
            id,
            firstName,
            lastName,
            gender,
            location,
            utrDoubles,
            ratingStatusSingles,
            ratingStatusDoubles,
            nationality,
            playerProfileImages,
            memberId,
            playerCollege,
            playerCollegeDetails,
            playerHighSchool,
            playerHighSchoolDetails,
            homeClub,
            descriptionShort,
            descriptionLong,
            email,
            classYearStatus,
        } = player;

        const userLoggedIn = auth?.user;
        const isCollegeViewType = clubProfileViewType === CLUB_PROFILE_VIEW_TYPES.COLLEGE;
        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollegeViewType);

        const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
        const playerDIvision = _.find(player.registeredDivisions, { divisionId: currentDivision });

        const hasRating = !!(player.myUtrSingles || player.myUtrDoubles || player.singlesUtr || player.doublesUtr);

        let description = '';
        if (descriptionLong) {
            description = [descriptionLong];
        } else {
            description = location?.display ? [location.display] : [];
        }

        let descriptionMobile = '';
        if (descriptionShort) {
            descriptionMobile = [descriptionShort];
        } else {
            descriptionMobile = location?.display ? [location.display] : [];
        }

        const descriptionItems = [
            ...(gender ? [gender.charAt(0)] : []),
            ...(description),
        ];

        const descriptionItemsMobile = [
            ...(gender ? [gender.charAt(0)] : []),
            ...(descriptionMobile),
        ];

        let collegeStringShort;
        let collegeStringLong;
        let highSchoolStringShort;
        let highSchoolStringLong;
        let clubCollegeDetailsMobile;

        if (playerCollege?.shortName) {
            collegeStringShort = playerCollege.shortName;
            collegeStringLong = playerCollege.displayName || playerCollege.shortName;
            if (playerCollegeDetails?.gradYear) {
                collegeStringShort += ` ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
                collegeStringLong += ` ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
                // if player is currently in college, show on mobile cards instead of location
                if (moment().diff(moment(playerCollegeDetails.gradYear)) < 0) {
                    clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerCollege.shortName} ('${moment(playerCollegeDetails.gradYear).format('YY')})`;
                }
            }
        }
        if (playerHighSchool?.shortName) {
            highSchoolStringShort = playerHighSchool.shortName;
            highSchoolStringLong = playerHighSchool.displayName || playerHighSchool.shortName;
            if (playerHighSchoolDetails?.gradYear) {
                highSchoolStringShort += ` ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
                highSchoolStringLong += ` ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
                // if player is currently in high school, show on mobile cards instead of location
                if (!clubCollegeDetailsMobile && moment().diff(moment(playerHighSchoolDetails.gradYear)) < 0) {
                    clubCollegeDetailsMobile = `${gender.charAt(0)} \u2022 ${playerHighSchool.shortName} ('${moment(playerHighSchoolDetails.gradYear).format('YY')})`;
                }
            }
        }

        const clubCollegeDetailsShort = [
            ...(homeClub ? [homeClub] : []),
            ...(collegeStringShort ? [collegeStringShort] : []),
            ...(highSchoolStringShort ? [highSchoolStringShort] : []),
        ];

        const clubCollegeDetailsLong = [
            ...(homeClub ? [homeClub] : []),
            ...(collegeStringLong ? [collegeStringLong] : []),
            ...(highSchoolStringLong ? [highSchoolStringLong] : []),
        ];

        const renderLinkIf = (content, condition, id) => {
            if (condition && id) {
                const href = `/profiles/${id}`;
                return (<Link to={href} data-testid={dataTestId && `${dataTestId}.card-link`}>{content}</Link>);
            }
            return (content);
        };

        const isCurrentUser = auth?.user && (auth.user.id === memberId);

        return renderLinkIf(
            <div className={`utr-card player-card ${showActionRequiredBackground ? 'action-required' : ''}`}>
                <div className={`list-view ${forceCardView || force.cardView ? 'd-none' : 'd-none d-md-block'}`}>
                    <div className="d-flex">
                        <div className="flex-grow">
                            <div className="row">
                                <div className="col-md-5">
                                    {!!rank && <div className="rank" data-testid={dataTestId && `${dataTestId}.desktop.rank`}>{rank}</div>}
                                    <div className="avatar-wrapper">
                                        <BackgroundImage
                                            baseUrl={'/v1/player/'}
                                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                            images={playerProfileImages}
                                            imageType={'icon'}
                                            parentStylesClass={'avatar d-inline-block'}
                                        />
                                        {nationalFlag && <img className="flag" src={nationalFlag} alt={nationality} data-testid={dataTestId && `${dataTestId}.desktop.flag`} />}
                                    </div>
                                    <div className="name-and-place">
                                        {firstName && lastName && <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{firstName} {lastName}</div>}
                                        {!(firstName && lastName) && email && <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{email}</div>}
                                        <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.place`}><Description desc={descriptionItems} data-testid={dataTestId && `${dataTestId}.desktop.place`} /></div>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className="row w-100">
                                        <div className={`${showPlayerStatus ? 'col-md-3' : 'col-md-4'}`}>
                                            {(userLoggedIn || showRatingNotLoggedIn) && hasRating && (
                                                <React.Fragment>
                                                    <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.singles-values`}>
                                                        <div
                                                            className={`value ${utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? 'text-lighter' : ''}`}
                                                            title={utrType === 'sanctioned' ? ratingStatusSingles : ''}
                                                            data-testid={dataTestId && `${dataTestId}.desktop.singles-utr`}
                                                        >
                                                            <Utr player={player} force={{ ratingType: 'singles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.singles-utr`} />
                                                        </div>
                                                        <div className="title" data-testid={dataTestId && `${dataTestId}.desktop.singles-label`}>
                                                            <UtrLabel player={player} force={{ ratingType: 'singles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.singles-label`} />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        <div className={`${showPlayerStatus ? 'col-md-3' : 'col-md-4'}`}>
                                            {(userLoggedIn || showRatingNotLoggedIn) && hasRating && (
                                                <React.Fragment>
                                                    <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.doubles-values`}>
                                                        <div
                                                            className={`value ${ratingStatusDoubles !== 'Rated' ? 'text-lighter' : ''}`}
                                                            title={utrType === 'sanctioned' ? ratingStatusDoubles : ''}
                                                            data-testid={dataTestId && `${dataTestId}.desktop.doubles-utr`}
                                                        >
                                                            <Utr player={player} force={{ ratingType: 'doubles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.doubles-utr`} />
                                                        </div>
                                                        <div className="title" data-testid={dataTestId && `${dataTestId}.desktop.doubles-label`}>
                                                            <UtrLabel player={player} force={{ ratingType: 'doubles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.desktop.doubles-label`} />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        {clubProfileViewType && !showPlayerStatus && (
                                            <React.Fragment>
                                                <div className="col-md-3">
                                                    <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.grad-class`}>
                                                        {clubProfileViewType === CLUB_PROFILE_VIEW_TYPES.COLLEGE && playerCollegeDetails && (
                                                            isNewRosterModel && classYearStatus
                                                                ? classYearStatus
                                                                : playerCollegeDetails.gradClassName
                                                        )}
                                                        {clubProfileViewType === CLUB_PROFILE_VIEW_TYPES.HIGHSCHOOL && playerHighSchoolDetails && (
                                                            isNewRosterModel && classYearStatus
                                                                ? classYearStatus
                                                                : playerHighSchoolDetails.gradClassName
                                                        )}
                                                    </div>
                                                </div>
                                                {this.props.addMemberLink && (
                                                    <div className="col-md-3">
                                                        <Link to={`${this.props.addMemberLink}`} data-testid={dataTestId && `${dataTestId}.desktop.add-member-link`}>Action Required: Complete Profile</Link>
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        )}
                                        {showClubCollegeDetails && !clubProfileViewType && !showPlayerStatus && clubCollegeDetailsShort.length > 0 && (
                                            <div className="col-md-6">
                                                <Dotdotdot clamp={2} title={clubCollegeDetailsLong}>
                                                    <Description desc={clubCollegeDetailsShort} noellipsis={true} data-testid={dataTestId && `${dataTestId}.desktop.college-details`} />
                                                </Dotdotdot>
                                            </div>
                                        )}
                                        {!!showPlayerStatus && (
                                            <div className="col-md-3">
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.registration-status`}>
                                                    {playerDIvision.registrationStatus}
                                                </div>
                                            </div>
                                        )}
                                        {!!showPlayerStatus && showPlayerPaymentStatus && (
                                            <div className="col-md-3">
                                                <div className="values text-lighter" data-testid={dataTestId && `${dataTestId}.desktop.payment-status`}>
                                                    {playerDIvision.paymentStatus}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bookmark justify-content-end">
                            {(!showSeeProfileLink && !isCurrentUser && !!memberId && !!player.memberId) && (
                                <div
                                    className="click-area"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        sendMessage(player);
                                    }}
                                    data-testid={dataTestId && `${dataTestId}.desktop.message-btn`}
                                >
                                    <i className={`utr utr-message fs18 text-teal`} />
                                </div>
                            )}
                            {menuOptions && (
                                <PopOverMenu
                                    horizontalEllipsis={false}
                                    menuItems={menuOptions}
                                    onSelected={menuOnSelected}
                                    data-testid={dataTestId && `${dataTestId}.desktop.popover-menu`}
                                />
                            )}
                            {!menuOptions && showSeeProfileLink && (
                                <Link to={`/profiles/${id}`} target="_blank" data-testid={dataTestId && `${dataTestId}.desktop.see-profile-link`}>
                                    <span className={`extra-card-link`}>View Profile</span>
                                </Link>
                            )}
                            {addOptionsSpace && !menuOptions && (
                                <div className="options-space" />
                            )}
                        </div>
                        {/* <div className={`col-md-1 ${utrType == 'sanctioned' ? '' : 'offset-md-2'}`}>
                                {menuOptions && (
                                    <PopOverMenu
                                        horizontalEllipsis={true}
                                        menuItems = {menuOptions}
                                        onSelected = {menuOnSelected}
                                    />
                                )}
                            </div> */}
                    </div>
                </div>
                <div className={`card-view ${forceCardView || force.cardView ? 'd-block' : 'd-block d-md-none'}`}>
                    <div className="row">
                        {showPlayerStatus && (
                            <React.Fragment>
                                <div className={`badge registration-status text-small`} data-testid={dataTestId && `${dataTestId}.mobile.registration-status`}>{playerDIvision.registrationStatus}</div>
                                <div className={`badge payment-status text-small`} data-testid={dataTestId && `${dataTestId}.mobile.payment-status`}>{playerDIvision.paymentStatus}</div>
                            </React.Fragment>
                        )}
                        <div className="col-8">
                            <div className="name-and-place">
                                {firstName && lastName && <div className="name h6" data-testid={dataTestId && `${dataTestId}.mobile.name`}><span className="text-medium" data-testid={dataTestId && `${dataTestId}.mobile.first-name`}>{firstName}</span> {lastName}</div>}
                                {!(firstName && lastName) && email && <div className="name h6" data-testid={dataTestId && `${dataTestId}.mobile.name`}><span className="text-medium" data-testid={dataTestId && `${dataTestId}.mobile.email-display`}>{email}</span></div>}
                                <div className="place" data-testid={dataTestId && `${dataTestId}.mobile.place`}>
                                    <Description desc={clubCollegeDetailsMobile || descriptionItemsMobile} data-testid={dataTestId && `${dataTestId}.mobile.place`} />
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="avatar-container ml-auto">
                                <BackgroundImage
                                    baseUrl={'/v1/player/'}
                                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                    images={playerProfileImages}
                                    imageType={'icon'}
                                    parentStylesClass={'avatar'}
                                />
                                {nationality && (
                                    <div className="flag-container">
                                        <img
                                            className="flag"
                                            src={nationalFlag}
                                            alt={nationality}
                                            data-testid={dataTestId && `${dataTestId}.mobile.flag`}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row profile-details">
                        <div className="col-4">
                            {(userLoggedIn || showRatingNotLoggedIn) && hasRating ? (
                                <div className="values" data-testid={dataTestId && `${dataTestId}.mobile.singles-values`}>
                                    <div className="title" data-testid={dataTestId && `${dataTestId}.mobile.singles-label`}>
                                        <UtrLabel player={player} force={{ ratingType: 'singles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.singles-label`} />
                                    </div>
                                    <div
                                        className={`value ${utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? 'text-lighter' : ''}`}
                                        title={utrType === 'sanctioned' && ratingStatusSingles !== 'Rated' ? ratingStatusSingles : ''}
                                        data-testid={dataTestId && `${dataTestId}.mobile.singles-utr`}
                                    >
                                        <Utr player={player} force={{ ratingType: 'singles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.singles-utr`} />
                                    </div>
                                </div>
                            ) : (
                                <div className="values">&nbsp;</div>
                            )}
                        </div>
                        <div className="col-4">
                            {(userLoggedIn || showRatingNotLoggedIn) && hasRating ? (
                                <div className="values" data-testid={dataTestId && `${dataTestId}.mobile.doubles-values`}>
                                    <div className="title" data-testid={dataTestId && `${dataTestId}.mobile.doubles-label`}>
                                        <UtrLabel player={player} force={{ ratingType: 'doubles', utrType, typeDots: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.doubles-label`} />
                                    </div>
                                    <div
                                        className={`value ${ratingStatusDoubles !== 'Rated' ? 'text-lighter' : ''}`}
                                        title={!utrDoubles ? 'Unrated' : ''}
                                        data-testid={dataTestId && `${dataTestId}.mobile.doubles-utr`}
                                    >
                                        <Utr player={player} force={{ ratingType: 'doubles', utrType, verifiedIcon: true, showDecimals }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.mobile.doubles-utr`} />
                                    </div>
                                </div>
                            ) : (
                                <div className="values">&nbsp;</div>
                            )}
                        </div>
                        <div className={`col-4 justify-content-end`}>
                            {menuOptions && (
                                <PopOverMenu
                                    horizontalEllipsis={true}
                                    menuItems={menuOptions}
                                    onSelected={menuOnSelected}
                                    data-testid={dataTestId && `${dataTestId}.mobile.popover-menu`}
                                />
                            )}
                            {!menuOptions && showSeeProfileLink && (
                                <span className={`extra-card-link`} data-testid={dataTestId && `${dataTestId}.mobile.see-profile-link`}>See Profile</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>,
            !showSeeProfileLink,
            id,

        );
    }
}

InvitedPlayerCard.propTypes = {
    rank: PropTypes.number,
    player: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        gender: PropTypes.string,
        location: PropTypes.shape({
            display: PropTypes.string,
        }),
        utrDoubles: PropTypes.number,
        ratingStatusSingles: PropTypes.string,
        ratingStatusDoubles: PropTypes.string,
        nationality: PropTypes.string,
        playerProfileImages: PropTypes.arrayOf(any),
        memberId: PropTypes.string,
        playerCollege: PropTypes.shape({
            shortName: PropTypes.string,
            displayName: PropTypes.string,
        }),
        playerCollegeDetails: PropTypes.shape({
            gradYear: PropTypes.string,
            gradClassName: PropTypes.string,
        }),
        playerHighSchool: PropTypes.shape({
            shortName: PropTypes.string,
            displayName: PropTypes.string,
        }),
        playerHighSchoolDetails: PropTypes.shape({
            gradYear: PropTypes.string,
            gradClassName: PropTypes.string,
        }),
        homeClub: PropTypes.string,
        descriptionShort: PropTypes.string,
        descriptionLong: PropTypes.string,
        email: PropTypes.string,
        registeredDivisions: PropTypes.arrayOf(PropTypes.shape({
            divisionId: PropTypes.string,
            registrationStatus: PropTypes.string,
            paymentStatus: PropTypes.string,
        })),
        myUtrSingles: PropTypes.number,
        myUtrDoubles: PropTypes.number,
        singlesUtr: PropTypes.number,
        doublesUtr: PropTypes.number,
    }).isRequired,
    currentDivision: PropTypes.string,
    showPlayerStatus: PropTypes.bool,
    showPlayerPaymentStatus: PropTypes.bool,
    utrType: PropTypes.string,
    menuOptions: PropTypes.arrayOf(any),
    menuOnSelected: PropTypes.func,
    showSeeProfileLink: PropTypes.bool,
    forceCardView: PropTypes.bool,
    force: PropTypes.shape({
        cardView: PropTypes.bool,
    }),
    addOptionsSpace: PropTypes.bool,
    showDecimals: PropTypes.bool,
    showClubCollegeDetails: PropTypes.bool,
    clubProfileViewType: PropTypes.string,
    showActionRequiredBackground: PropTypes.bool,
    auth: PropTypes.shape({
        user: PropTypes.shape({
            id: PropTypes.string,
        }),
    }),
    showRatingNotLoggedIn: PropTypes.bool,
    sendMessage: PropTypes.func,
    sportTypeId: PropTypes.string,
    addMemberLink: PropTypes.string,
    checkGate: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    featureGates: PropTypes.object,
    'data-testid': PropTypes.string,
};

InvitedPlayerCard.defaultProps = {
    'data-testid': null,
    rank: null,
    currentDivision: '',
    showPlayerStatus: false,
    showPlayerPaymentStatus: false,
    utrType: '',
    menuOptions: [],
    menuOnSelected: () => {},
    showSeeProfileLink: false,
    forceCardView: false,
    force: {
        cardView: false,
    },
    addOptionsSpace: false,
    showDecimals: false,
    showClubCollegeDetails: false,
    clubProfileViewType: '',
    showActionRequiredBackground: false,
    auth: {
        user: null,
    },
    showRatingNotLoggedIn: false,
    sendMessage: () => {},
    sportTypeId: '',
    addMemberLink: '',
    checkGate: null,
    featureGates: null,
};

export default withAuth(InvitedPlayerCard);
